import { Dropdown, Flex, Typography } from "antd"
import cls from "classname"

import Icon from "../../../../../Icon"
import { MONTH_STATUSES, TIER_CONTROL } from "../monitoringCopy"
import { ECP_TIERS, formatCount, formatRate } from "../programLimits"

import "./EcpTierControl.less"

const { Text } = Typography

const TierDropdownContent = ({ lastClosedMonth, tier }) => {
  const factLine = () => {
    if (!lastClosedMonth) return null

    const figures = `${lastClosedMonth.month_name}: ${formatCount(
      lastClosedMonth.chargeback_count
    )} chargebacks · ${formatRate(lastClosedMonth.chargeback_rate)}`

    if (lastClosedMonth.status === MONTH_STATUSES.PENDING)
      return `${figures} — these figures are not final, so the ${tier} tier is retained.`

    if (lastClosedMonth.tier) return `${figures} — these figures produced the ${tier} tier.`

    return `${figures} — a clean month that produced no tier. The ${tier} tier is retained until three consecutive clean months are completed.`
  }

  return (
    <div className="ecp-tier-menu">
      <Text type="secondary" className="ecp-tier-menu__lead">
        {TIER_CONTROL.lead}
      </Text>
      {TIER_CONTROL.tiers.map((row) => (
        <Flex key={row.key} gap={8} align="flex-start" className="ecp-tier-menu__row">
          <span className={cls("ecp-tier-chip", row.key)}>{row.label}</span>
          <Text type="secondary">
            <Text strong className="ecp-tier-menu__thresholds">
              {row.thresholds}
            </Text>{" "}
            {row.name}. {row.consequences}
          </Text>
        </Flex>
      ))}
      {lastClosedMonth && (
        <div className="ecp-tier-menu__fact">
          {/* Figures are neutral; only the tier chip carries colour (§6 R10). */}
          <Text type="secondary">{factLine()}</Text>
        </div>
      )}
    </div>
  )
}

const EcpTierControl = ({ tier, lastClosedMonth }) => {
  if (!tier || !lastClosedMonth) return null

  const tierKey = tier.toLowerCase()
  const tierLabel = ECP_TIERS[tier.toUpperCase()]?.label ?? tier.toUpperCase()

  return (
    <Dropdown
      trigger={["click"]}
      placement="bottomLeft"
      overlayClassName="ecp-tier-dropdown"
      getPopupContainer={() => document.getElementById("main-layout") || document.body}
      dropdownRender={() => (
        <TierDropdownContent lastClosedMonth={lastClosedMonth} tier={tierLabel} />
      )}
    >
      <button type="button" className={cls("ecp-tier-trigger", tierKey)}>
        {tierLabel}
        <Icon type="chevron_down_small" />
      </button>
    </Dropdown>
  )
}

export default EcpTierControl
